<div
    mdbModal
    #updatePaymentMethodModal="mdbModal"
    id="update-payment-method-modal"
    class="modal fade overflow-y-auto"
    tabindex="-1"
    role="dialog"
    (closed)="hideDialog()"
>
    <div
        class="modal-dialog modal-lg modal-dialog-centered edit-card-content"
        role="document"
        *ngIf="isReady"
    >
        <div class="modal-content update-payment-method-content">
            <div class="modal-header mt-1" id="update-payment-method-header">
                <div class="pull-left">
                    <h3 id="update-payment-method-header-title" data-test="update-payment-method-header-title">
                        <i class="fa fa-credit-card"></i> Update Payment Method
                    </h3>
                </div>
                <button
                    type="button"
                    class="close pull-right close-align modal-close-button"
                    aria-label="Close"
                    (click)="hideDialog()"
                >
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="update-payment-method-body">
                <div class="container-fluid">
                    <div class="row mb-4" id="update-credit-card-details-row">
                        <div class="col-md-12 col-sm-12 col-xs-12">
                            <p class="h5 text-left py-3 text-muted" data-test="alternate-payment-method-heading">
                                <strong>Credit Card Details</strong><br />
                            </p>

                            <span><strong>Card Type:</strong> {{paymentMethod.cardTypeFullName}}</span><br />
                            <span><strong>Last 4 Digits:</strong> {{paymentMethod.cardLast4Digits}}</span><br />
                            <span><strong>Expiration Month:</strong> {{paymentMethod.cardExpirationMonth}}</span><br />
                            <span><strong>Expiration Year:</strong> {{paymentMethod.cardExpirationYear}}</span><br />
                            <span><strong>Active:</strong> {{paymentMethod.isActive ? 'Yes' : 'No'}}</span><br />
                            <span><strong>Default:</strong> {{paymentMethod.isDefault ? 'Yes' : 'No'}}</span><br />

                            <hr />

                            <div>
                                <mdb-checkbox [(ngModel)]="paymentMethod.isDefault"> 
                                    Set as default credit card? 
                                </mdb-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer" id="credit-card-modal-footer">
                    <button type="button" class="btn btn-danger" (click)="hideDialog()" [disabled]="isSaving">Cancel</button>
                    <button type="button" class="btn btn-primary" (click)="changeDefaultPaymentMethod()" [disabled]="isSaving">Update</button>
                </div>
            </div>
        </div>
    </div>
</div>
